




























































































import Base from '@/views/Base';
import {Component, Prop} from 'vue-property-decorator';
import WSwitch from '@/components/WSwitch.vue';
import {SelectOption} from '@/models/common';
import SurveyService from '@/service/SurveyService';
import {Element} from '@/models/Presentation';
import {Survey} from '@/models/Survey';
import {ACCEPT_IMAGE} from '@/utils/files';
import PresentationService from "@/service/PresentationService";

@Component({
  components: { WSwitch }
})
export default class AddSurveyModal extends Base {
  @Prop({ default: null }) editItem!: Element | null;

  surveys: SelectOption[] = [{ text: this.$t('conference.noSurveyForm') as string, value: null, disabled: true }];
  selectedSurvey: number | null = null;

  backgroundImage: {
    url: string | null;
    file: File | null;
  } = {
    url: null,
    file: null
  };

  ACCEPT_IMAGE = ACCEPT_IMAGE;

  shown(): void {
    if (!this.editItem) {
      this.reset();
      return;
    }
    this.selectedSurvey = Number(this.editItem.surveyFormId) || null;
    this.backgroundImage.file = null;
    if (!this.editItem.backgroundFilename || !this.editItem.presentationId) {
      this.backgroundImage.url = null;
    } else {
      this.backgroundImage.url = PresentationService.getSurveyBackgroundUrl(this.editItem.presentationId, this.editItem.id, this.editItem.backgroundFilename, this.user.resourceAccessToken);
    }
    this.surveySelected();
  }

  show() {
    this.getSurveys();
  }

  getSurveys(): void {
    SurveyService.getActiveSurveys(0, 9999, 'dateCreated', 'DESC')
      .then(surveys => {
        this.surveys.splice(1, this.surveys.length);
        if (surveys.empty) return;
        this.surveys.push(...surveys.content.map(survey => ({
          text: survey.label || survey.title,
          value: survey.id,
          data: survey
        }) as SelectOption));
      })
      .catch(this.showNetworkError);
  }

  submit(ok: () => void): void {
    this.$emit('add-survey-form', this.selectedSurvey, this.backgroundImage.file, this.editItem?.id);
    ok();
  }

  hidden(): void {
    this.$emit('hidden');
    this.reset();
  }

  reset(): void {
    this.selectedSurvey = null;
    this.backgroundImage.file = null;
    this.backgroundImage.url = null;
  }

  get surveyFormUrl(): string | null {
    if (this.selectedSurvey == null) {
      return null;
    }
    const survey = this.surveys.find(s => s.value == this.selectedSurvey)?.data as Survey;
    if (survey) {
      return (process.env.VUE_APP_SURVEY_URL ?? '') + survey.url + '?event=true';
    }
    return null;
  }

  surveySelected() {
    const iframe = this.$refs['survey-preview'] as HTMLIFrameElement;
    if (!iframe.contentWindow) {
      console.error('iframe contentWindow is null');
      return;
    }
    iframe.onload = () => {
      console.log('iframe loaded');
      if (!iframe.contentWindow) {
        console.error('iframe contentWindow is null');
        return;
      }
      iframe.contentWindow.postMessage(this.backgroundImage.url, '*');
    };
  }

  pictureUploaded(files: File[]) {
    if (files.length == 0) {
      return;
    }
    const reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = (e) => {
      if (e.target) {
        this.backgroundImage.url = e.target.result as string;
        this.backgroundImage.file = files[0];
        console.log('Logo uploaded');

        const iframe = this.$refs['survey-preview'] as HTMLIFrameElement;

        if (!iframe.contentWindow) {
          console.error('iframe contentWindow is null');
          return;
        }
        iframe.contentWindow.postMessage(this.backgroundImage.url, '*');
        console.log('send message to iframe');
      }
    };


    this.backgroundImage.file = files[0];
  }

  deleteBackground() {
    this.backgroundImage.url = null;
    this.backgroundImage.file = null;

    const iframe = this.$refs['survey-preview'] as HTMLIFrameElement;
    if (!iframe.contentWindow) {
      console.error('iframe contentWindow is null');
      return;
    }
    console.log('Delete background');
    iframe.contentWindow.postMessage('', '*');

    // this.survey.backgroundChanged = true;
  }
}
